import React, { useState, useRef, useEffect } from 'react';

export default function FilterCell({ column, data, value = {}, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(Array.isArray(value.select) ? value.select : (value.select ? [value.select] : []));
  const popupRef = useRef();
  const buttonRef = useRef();
  const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });

  // הפקת ערכים ייחודיים מהנתונים
  const uniqueOptions = Array.from(new Set(data.map(row => row[column.field]).filter(v => v !== undefined && v !== null && v !== '')));
  const filteredOptions = uniqueOptions.filter(opt => String(opt).includes(search));

  // סגירת popup בלחיצה מחוץ
  useEffect(() => {
    function handleClickOutside(e) {
      if (popupRef.current && !popupRef.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  // חישוב מיקום popup
  useEffect(() => {
    if (open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPopupPosition({
        top: rect.bottom + window.scrollY + 4,
        right: window.innerWidth - rect.right + window.scrollX
      });
    }
  }, [open]);

  if (column.type === 'sum') return null;

  // בחירה/ביטול ערך
  const toggleOption = (opt) => {
    setSelected(prev => prev.includes(opt) ? prev.filter(v => v !== opt) : [...prev, opt]);
  };
  // בחירה/ביטול הכל
  const toggleAll = () => {
    if (selected.length === filteredOptions.length) setSelected([]);
    else setSelected(filteredOptions);
  };
  // בחירה רק ריקים
  const toggleEmpty = () => {
    if (selected.includes('')) setSelected(selected.filter(v => v !== ''));
    else setSelected([...selected, '']);
  };

  return (
    <span style={{ display: 'inline-block', position: 'relative' }}>
      {/* אייקון פילטר */}
      <span
        ref={buttonRef}
        style={{ cursor: 'pointer', fontSize: '1.1em', verticalAlign: 'middle' }}
        title="סנן"
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
      >
        {/* SVG של פילטר */}
        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" style={{verticalAlign: 'middle'}} xmlns="http://www.w3.org/2000/svg">
          <path d="M3 5h18l-7 9v5l-4 2v-7L3 5z" stroke="#6d4c2f" strokeWidth="2" fill="none" strokeLinejoin="round"/>
        </svg>
      </span>
      {/* popup */}
      {open && (
        <div ref={popupRef} style={{
          position: 'fixed',
          top: `${popupPosition.top}px`,
          right: `${popupPosition.right}px`,
          zIndex: 9999,
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: 8,
          boxShadow: '0 4px 16px rgba(0,0,0,0.13)',
          minWidth: 180,
          padding: 12
        }}>
          <div style={{ marginBottom: 8 }}>
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="חיפוש"
              style={{ width: '100%', padding: 6, borderRadius: 6, border: '1px solid #eee' }}
            />
          </div>
          <div style={{ maxHeight: 120, overflowY: 'auto', marginBottom: 8 }}>
            <div style={{ marginBottom: 4 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <input type="checkbox" checked={selected.length === filteredOptions.length} onChange={toggleAll} /> (בחר הכל)
              </label>
            </div>
            {filteredOptions.map(opt => (
              <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <input
                  type="checkbox"
                  checked={selected.includes(opt)}
                  onChange={() => toggleOption(opt)}
                />
                {String(opt)}
              </label>
            ))}
            <div style={{ marginTop: 4 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <input type="checkbox" checked={selected.includes('')} onChange={toggleEmpty} /> (ריקים)
              </label>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 8 }}>
            <button
              style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #bbb', background: '#f8f9fa', cursor: 'pointer' }}
              onClick={() => { 
                // נקה סינון = בחר הכל (כולל ריקים) - כל האופציות הזמינות, לא רק אלה שמוצגות אחרי חיפוש
                const allOptions = [...uniqueOptions];
                // הוסף ריקים אם יש שורות ריקות
                const hasEmpty = data.some(row => !row[column.field] || row[column.field] === '');
                if (hasEmpty) {
                  allOptions.push('');
                }
                setSelected(allOptions);
                onChange('select', allOptions);
                setOpen(false);
              }}
            >נקה סינון</button>
            <button
              style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #bbb', background: '#f8f9fa', cursor: 'pointer' }}
              onClick={() => { setOpen(false); }}
            >ביטול</button>
            <button
              style={{ padding: '6px 16px', borderRadius: 6, border: '1px solid #6d4c2f', background: '#fff', color: '#6d4c2f', cursor: 'pointer' }}
              onClick={() => { onChange('select', selected); setOpen(false); }}
            >אישור</button>
          </div>
        </div>
      )}
    </span>
  );
} 